<template>
    <eSesjaModal class="visualization-activity-export">
        <eSesjaModalHeader @close="close">
            {{$t('com.file.visualization-link-activity.export')}}
        </eSesjaModalHeader>
        <eSesjaModalBody class="d-flex flex-column gap-3">
            <p class="export-info">{{$t('com.file.visualization-link-activity.export-info')}}</p>
            <section class="d-flex flex-column gap-1">
                <SearchLabelComponent :label="$t('com.file.export-email-modal.file-format')" />
                <SearchSelectComponent v-model="formatOptions.selected" :options="formatOptions.available" style="width: 100%;" />
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="close">
                {{ $t('com.global.cancel') }}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @save="download" :disabled="formatOptions.selected.value === null">
                {{$t('com.global.download')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
    import SearchLabelComponent from "@/components/BasicControls/SearchLabelComponent.vue";
    import SearchSelectComponent from "@/components/BasicControls/SearchSelectComponent.vue";
    import SettingsService from "@/services/settings.service";
    import alertsHelper from "@/helpers/alerts.helper";
    import { fileDownloadHelper } from "@/helpers/file.download.helper";

    export default {
        name: "VisualizationLinkActivityExportModal",
        components: {
            SearchLabelComponent,
            SearchSelectComponent
        },
        data() {
            return {
                // wartości odpowiadają enumowi ExportFormat po stronie serwera
                formatOptions: {
                    selected: { value: 10, label: "Microsoft Excel (.xlsx)" },
                    available: [
                        { value: 10, label: "Microsoft Excel (.xlsx)" },
                        { value: 0, label: "Microsoft Word (.docx)" }
                    ]
                }
            }
        },
        methods: {
            close() {
                this.$store.commit("setVisualizationLinkActivityExportModalStatus", false);
            },
            async download() {
                try {
                    this.$store.commit("showLoader");

                    const response = await SettingsService.exportVisualizationLinkActivity(this.formatOptions.selected.value);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    fileDownloadHelper(response);
                    this.close();
                    this.$swal(alertsHelper.successAlert(
                        this.$t('com.file.export-email-modal.file-downloades-success'),
                        this.$t('com.global.success')));
                }
                catch (e) {
                    console.log(e);
                }
                finally {
                    this.$store.commit("hideLoader");
                }
            }
        }
    }
</script>
<style lang="scss">
    .visualization-activity-export {
        .esesja-search-component-select__control {
            width: 100%;
        }

        /*
         * Własna nazwa klasy zamiast .info - IntegrationImportantDataSettings ma niescopowany styl
         * .info { text-align: center; ... }, który wyciekał na ten akapit.
         */
        .export-info {
            font-size: 13px;
            color: #666c7a;
            margin: 0px;
            text-align: left;
        }

        /* odstęp na stopce, poza przewijaną treścią */
        .esesja-modal__wraper__body__bottom {
            padding-top: 20px;
        }
    }
</style>
